import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { createContext, MouseEvent } from 'react'
import { PaymentStatus } from 'src/constants/payment/enums'
import { Payment } from 'src/interfaces/payment'
import { defaultColumnManagerContext, IColumnManagerContext } from 'src/interfaces/columnManager'

export interface IPaymentsTableContext extends IColumnManagerContext {
  notPaidPaymentsAmount: number

  selectedRows: GridRowSelectionModel
  setSelectedRows(rowSelectionModel: GridRowSelectionModel): void

  selectedPayments: Array<Payment>

  searchQuery: string
  setSearchQuery(value: string): void

  statusFilter: Array<PaymentStatus>
  setStatusFilter(statusFilter: Array<PaymentStatus>): void

  updatePayment(payment: Payment): void

  // edit action
  actionAnchor: null | HTMLElement
  paymentToAction: Payment | null
  openPaymentsItemAction(event: MouseEvent<HTMLButtonElement>, payment: Payment): void
  closePaymentsItemAction(): void
  clearPaymentsItemAction(): void
}

export const PaymentsTableContext = createContext<IPaymentsTableContext>({
  ...defaultColumnManagerContext,

  notPaidPaymentsAmount: 0,

  selectedRows: [],
  setSelectedRows: () => {},

  selectedPayments: [],

  searchQuery: '',
  setSearchQuery: () => {},

  statusFilter: [],
  setStatusFilter: () => {},

  updatePayment: () => {},

  actionAnchor: null,
  paymentToAction: null,
  openPaymentsItemAction: () => {},
  closePaymentsItemAction: () => {},
  clearPaymentsItemAction: () => {},
})
